<template>
  <v-ons-col>
    <v-ons-row class="color-chart-text">
      <v-ons-col class="color-chart-min">少ない</v-ons-col>
      <v-ons-col class="color-chart-max">多い</v-ons-col>
    </v-ons-row>
    <div class="color-chart" />
  </v-ons-col>
</template>

<script>
export default {
};
</script>

<style scoped lang="scss">
.color-chart {
  margin-left: 1em;
  margin-right: 1em;
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#0000ff+25,00ff00+55,fbff28+85,ff0000+100 */
  background: #0000ff; /* Old browsers */
  background: -moz-linear-gradient(left,  #0000ff 25%, #00ff00 55%, #fbff28 85%, #ff0000 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(left,  #0000ff 25%,#00ff00 55%,#fbff28 85%,#ff0000 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right,  #0000ff 25%,#00ff00 55%,#fbff28 85%,#ff0000 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  &-min {
    color: #0000ff;
  }
  &-max {
    color: #ff0000;
  }
}
</style>



// WEBPACK FOOTER //
// congestion.vue?c5ee15ce